import { render, staticRenderFns } from "./Validation.vue?vue&type=template&id=2915cf6a&"
import script from "./Validation.vue?vue&type=script&lang=ts&"
export * from "./Validation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports